import React from 'react';
import { CtaBlock } from '../CtaButton';
import { AssuranceRow } from './AssuranceRow';
import { MOCKUP_URL } from '../../data/images';
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-forest px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-76" data-mp="9uwka1004tw1">
      <div className="mx-auto max-w-4xl" data-id="element-77" data-mp="53o5sqjteic0">
        <h2 id="final-heading" className="mx-auto max-w-3xl font-display text-[2.4rem] font-bold leading-[1.06] text-brand-ivory sm:text-[3.2rem]" data-id="element-78" data-mp="52leihikydvk">
          Deine nächste Nageldesign-Schulung beginnt{' '}
          <em className="italic text-brand-butter" data-id="element-79" data-mp="stquqxsfn86e">mit einer besseren Vorbereitung.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-80" data-mp="nuo087a2wkco">
          Nutze dein Fachwissen – und bring mehr Struktur in deine Unterrichtsplanung.
        </p>

        <img src={MOCKUP_URL} alt="Das komplette System Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[520px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.4))'
      }} data-id="element-81" data-mp="2pmalds7ahl18" />

        <CtaBlock label="Nail Educator Ready™ jetzt sichern" tone="dark" className="mt-10" data-id="element-82" data-mp="2zh676fkwo67q" />
        <AssuranceRow tone="dark" className="mt-5" data-id="element-83" data-mp="34ah7ryz4jqr7" />
      </div>
    </section>;
}